module.exports = __webpack_public_path__ + "img/2.4e1bee17.png";